import Service from "../../service";

const PastoralService = {
  getPastoralEvents: async ({ token, page, limit }) => {
    try {
      return await Service.get(
        `/pastoral/events/?current_page=${page}&items_per_page=${limit}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getPastoralFeeds: async ({ token, page, limit }) => {
    try {
      return await Service.get(
        `/pastoral/feed/?current_page=${page}&items_per_page=${limit}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getPastoralTasks: async ({ token, page, limit, eventTypeId }) => {
    try {
      return await Service.get(
        `/pastoral/tasks/?current_page=${page}&items_per_page=${limit}${
          eventTypeId ? `&eventTypeId=${eventTypeId}` : ""
        }`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getMembers: async ({ token, page }) => {
    try {
      return await Service.get(
        `/pastoral/contacts/?current_page=${page}&items_per_page=5000`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getEventTypes: async ({ token, page, limit = 5000, search = "" }) => {
    try {
      return await Service.get(
        `/pastoral/eventTypes/?current_page=${page}&items_per_page=${limit}${
          search ? `&search=${search}` : ""
        }`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  createEventType: async ({ data, token }) => {
    try {
      return await Service.post({ url: `/pastoral/eventTypes`, data, token });
    } catch (error) {
      throw error;
    }
  },

  updateEventType: async ({ eventTypeId, data, token }) => {
    try {
      return await Service.update({
        url: `/pastoral/eventTypes/${eventTypeId}`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  deleteEventType: async ({ token, id }) => {
    try {
      return await Service.remove({ url: `/pastoral/eventTypes/${id}`, token });
    } catch (error) {
      throw error;
    }
  },

  getEventUsers: async ({ token, page }) => {
    try {
      return await Service.get(
        `/pastoral/users/?current_page=${page}&items_per_page=5000`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  createEvent: async ({ data, token }) => {
    try {
      return await Service.post({ url: "/pastoral/events", data, token });
    } catch (error) {
      throw error;
    }
  },
  createTask: async ({ data, token }) => {
    try {
      return await Service.post({ url: "/pastoral/tasks", data, token });
    } catch (error) {
      throw error;
    }
  },

  updateTask: async ({ taskId, token, data }) => {
    try {
      return await Service.update({
        url: `/pastoral/tasks/${taskId}`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  getEventsFollowup: async ({ token, eventId }) => {
    try {
      return await Service.get(`/pastoral/events/${eventId}/followup`, token);
    } catch (error) {
      throw error;
    }
  },

  createEventsFollowup: async ({ data, eventId, token }) => {
    try {
      return await Service.post({
        url: `/pastoral/events/${eventId}/followup`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  getEventsByEventTypeId: async ({ token, eventTypeId }) => {
    try {
      return await Service.get(`/pastoral/events/${eventTypeId}`, token);
    } catch (error) {
      throw error;
    }
  },
  getEventById: async ({ token, eventId }) => {
    try {
      return await Service.get(
        `/pastoral/events/event/id/?eventId=${eventId}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  updateEvent: async ({ data, token, eventId }) => {
    try {
      return await Service.update({
        url: `/pastoral/events/${eventId}`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  deleteEvent: async ({ token, eventId }) => {
    try {
      return await Service.remove({
        url: `/pastoral/events/${eventId}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getTasksAutomation: async ({ token, page, limit, payload }) => {
    try {
      return await Service.post({
        url: `/pastoral/triggers/list?current_page=${page}&items_per_page=${limit}`,
        token,
        data: payload,
      });
    } catch (error) {
      throw error;
    }
  },

  createTaskAutomation: async ({ data, token }) => {
    try {
      return await Service.post({ url: "/pastoral/triggers", data, token });
    } catch (error) {
      throw error;
    }
  },

  deleteTaskAutomation: async ({ token, id }) => {
    try {
      return await Service.remove({ url: `/pastoral/triggers/${id}`, token });
    } catch (error) {
      throw error;
    }
  },
  updateTaskAutomation: async ({ data, token, id }) => {
    try {
      return await Service.update({
        url: `/pastoral/triggers/${id}`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  getScheduleReports: async ({ token, page, limit, payload }) => {
    try {
      return await Service.post({
        url: `/pastoral/reports/list?current_page=${page}&items_per_page=${limit}`,
        token,
        data: payload,
      });
    } catch (error) {
      throw error;
    }
  },

  createScheduleReports: async ({ data, token }) => {
    try {
      return await Service.post({ url: "/pastoral/reports", data, token });
    } catch (error) {
      throw error;
    }
  },

  updateScheduleReports: async ({ reportId, token, data }) => {
    try {
      return await Service.update({
        url: `/pastoral/reports/${reportId}`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  deleteScheduleReports: async ({ token, reportId }) => {
    try {
      return await Service.remove({
        url: `/pastoral/reports/${reportId}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  getGroups: async ({ token, page }) => {
    try {
      return await Service.get(
        `/pastoral/groups/?current_page=${page}&items_per_page=5000`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  createGroup: async ({ data, token }) => {
    try {
      return await Service.post({ url: "/pastoral/groups", data, token });
    } catch (error) {
      throw error;
    }
  },

  updateGroup: async ({ groupId, token, data }) => {
    try {
      return await Service.update({
        url: `/pastoral/groups/${groupId}`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  deleteGroup: async ({ token, groupId }) => {
    try {
      return await Service.remove({
        url: `/pastoral/groups/${groupId}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  getContacts: async ({ token, page }) => {
    try {
      return await Service.get(
        `/pastoral/contacts/?current_page=${page}&items_per_page=5000`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getContactsByGroupId: async ({ token, groupId }) => {
    try {
      return await Service.get(
        `/pastoral/groups/${groupId}/subscribers`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  addContactToGroup: async ({ data, token, groupId }) => {
    try {
      return await Service.post({
        url: `/pastoral/groups/${groupId}/subscribers`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  deleteContactToGroup: async ({ token, groupId, contactId }) => {
    try {
      return await Service.remove({
        url: `/pastoral/groups/${groupId}/subscribers/${contactId}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  updateContactToGroup: async ({ data, token, groupId, contactId }) => {
    try {
      return await Service.update({
        url: `/pastoral/groups/${groupId}/subscribers/${contactId}`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  getFrequency: async ({ token, page }) => {
    try {
      return await Service.get(`/pastoral/reports/frequency/list`, token);
    } catch (error) {
      throw error;
    }
  },
  createNewClergy: async ({ data, token }) => {
    try {
      return await Service.post({ url: `/pastoral/users`, data, token });
    } catch (error) {
      throw error;
    }
  },
  updateClergy: async ({ data, token }) => {
    try {
      return await Service.update({ url: `/pastoral/users`, token, data });
    } catch (error) {
      throw error;
    }
  },
  generateNewPassword: async ({ eventTypeId, data, token }) => {
    try {
      return await Service.update({
        url: `/pastoral/users/password`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },
  updateFollowup: async ({ data, eventId, token }) => {
    try {
      return await Service.update({
        url: `/pastoral/events/followup/${eventId}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  deleteUpdateById: async ({ token, id }) => {
    try {
      return await Service.remove({
        url: `/pastoral/events/followup/${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
};

export default PastoralService;
